// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"439":"blueprint-icons-all-paths-loader","569":"blueprint-icons-split-paths-by-size-loader"}[chunkId] + "." + {"439":"d8dc3383","569":"1b91fdd7"}[chunkId] + ".chunk.js";
};